import { z } from 'zod';
import { TouchTargetBehavior } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { AdminTableRow } from 'apps/sigma2-ui/src/components/AdminLayout';
import { Setter } from 'libs/end-to-end/src/ui-types';
import { ListItem } from 'libs/end-to-end/src/types/generic/generic';

export type OrganizationSecretSelectionDisplayMode =
  | 'select'
  | 'create'
  | 'edit';

export const EditSecretOperation = z.enum(['no-change', 'edit', 'clear']);
export type EditSecretOperation = z.infer<typeof EditSecretOperation>;
export const EditSecretOperations = Object.values(EditSecretOperation.Values);

export interface OrganizationSecretSelectionModalHook {
  modalTitle: string;
  goToCreateSecretButtonLabel: string;
  goToCreateSecretButtonBehavior: TouchTargetBehavior;
  goToSelectSecretButtonLabel: string;
  goToSelectSecretButtonBehavior: TouchTargetBehavior;
  displayMode: OrganizationSecretSelectionDisplayMode;
  secretRows: AdminTableRow[];
  secretHeadings: string[];
  editSecretId: string;
  createOnComplete: OnOrganizationSecretCreateCompleteFn;
  editOnComplete: OnOrganizationSecretEditCompleteFn;
  reloadButtonBehavior: TouchTargetBehavior;
  reloadButtonLabel: string;
}

export type OnOrganizationSecretCreateCompleteFn = (
  savedSecretId: string,
) => void;

export interface OrganizationSecretCreateComponentHook {
  createSecretDescription: string;
  setCreateSecretDescription: Setter<string>;
  createSecretValue: string;
  setCreateSecretValue: Setter<string>;
  createSecretTitle: string;
  createSecretButtonLabel: string;
  createSecretButtonBehavior: TouchTargetBehavior;
  createSecretDescriptionLabel: string;
  createSecretValueLabel: string;
  createSecretButtonDisabled: boolean;
}

export type OnOrganizationSecretEditCompleteFn = (
  savedSecretId: string,
) => void;

export interface OrganizationSecretEditComponentHook {
  editSecretDescription: string;
  setEditSecretDescription: Setter<string>;
  editSecretValue: string | null;
  setEditSecretValue: Setter<string | null>;
  editSecretTitle: string;
  editSecretButtonLabel: string;
  editSecretButtonBehavior: TouchTargetBehavior;
  editSecretDescriptionLabel: string;
  editSecretValueLabel: string;
  editSecretValueOperationLabel: string;
  editSecretValueOperation: EditSecretOperation;
  setEditSecretValueOperation: Setter<EditSecretOperation>;
  editSecretValueOperations: ListItem<EditSecretOperation>[];
  editSecretButtonDisabled: boolean;
}
